import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';

export function getBoxHeight(event: ICalendarData, boxHeight: number) {
    const eventStartTime = new Date(`0001-01-01 ${event.StartTime}`).getTime();
    const eventEndTime = new Date(`0001-01-01 ${event.EndTime}`).getTime();
    const boxRatio = ((eventEndTime - eventStartTime) / (60 * 60 * 1000)) * 2;
    return boxHeight * boxRatio;
}

export function getBoxColor(event: ICalendarData) {
    switch (event.GroupType) {
        case 'open':
            return 'open';
        case 'masterclass':
            return 'masterclass';
        case 'theory':
            return 'theory';
        case 'party':
            return 'party';
        case 'practice':
            return 'party';
        default:
            return 'kurs';
    }
}

export function getBoxBackColor(event: ICalendarData) {
    return 'white';
    switch (event.GroupType) {
        case 'open':
            return 'lighten2';
        case 'masterclass':
            return 'black';
        case 'theory':
            return 'lighten3';
        case 'party':
            return 'lighten4';
        default:
            return 'lighten1';
    }
}
